import { Grid, MenuItem, Select, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';

export const OrdersTableFilters = ({
  statusFilter,
  setStatusFilter,
  statusOptions,
  orderIdFilter,
  setOrderIdFilter,
  dateFilter,
  setDateFilter,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const parsedDateFilter = useMemo(() => {
    if (!dateFilter) {
      return null;
    }

    const parsedDate = dayjs(dateFilter);
    return parsedDate.isValid() ? parsedDate : null;
  }, [dateFilter]);

  useEffect(() => {
    setSelectedDate(parsedDateFilter);
  }, [parsedDateFilter]);

  return (
    <Grid container alignItems={'center'} spacing={1}>
      <Grid item>
        <Select
          size='small'
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          fullWidth
          sx={{ width: '12rem' }}
          displayEmpty
        >
          {statusOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
        <TextField
          size='small'
          placeholder='No. de orden'
          value={orderIdFilter}
          onChange={(e) => setOrderIdFilter(e.target.value)}
        />
      </Grid>
      <Grid item>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
          <DatePicker
            format='DD/MM/YYYY'
            value={selectedDate}
            onChange={(newValue) => {
              setSelectedDate(newValue);

              if (!newValue) {
                setDateFilter('');
              }
            }}
            onAccept={(acceptedValue) => {
              if (!acceptedValue || !acceptedValue.isValid()) {
                setDateFilter('');
                return;
              }

              setDateFilter(acceptedValue.format('YYYY-MM-DD'));
            }}
            slotProps={{
              textField: {
                size: 'small',
                placeholder: 'dd/mm/aaaa',
              },
              actionBar: {
                actions: ['clear', 'accept'],
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};
